import React, { forwardRef } from 'react';
import { useRefresh } from 'react-admin';

import { DialogoCompra } from '../../Components';

const Container = forwardRef((props, ref) => {
  const refresh = useRefresh();
  function handleClose() {
    refresh();
  }
  return <DialogoCompra ref={ref} handleClose={handleClose} />;
});

export default Container;
